import { render, staticRenderFns } from "./skeleton-hotelinfo.vue?vue&type=template&id=59d1b4bc&scoped=true&"
import script from "./skeleton-hotelinfo.vue?vue&type=script&lang=js&"
export * from "./skeleton-hotelinfo.vue?vue&type=script&lang=js&"
import style0 from "./skeleton-hotelinfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./skeleton-hotelinfo.vue?vue&type=style&index=1&id=59d1b4bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1b4bc",
  null
  
)

export default component.exports